import { useState } from 'react'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'
import { InputText } from '#app/components/ui/input-text'

interface ARTEmployeesScreenProps {
	onNext: (data: {
		numEmpleados: string
		masaSalarial: string
		ubicacion: string
	}) => void
	onBack: () => void
	data?: {
		numEmpleados?: string
		masaSalarial?: string
		ubicacion?: string
	}
}

export function ARTEmployeesScreen({
	onNext,
	onBack,
	data,
}: ARTEmployeesScreenProps) {
	const [formData, setFormData] = useState({
		numEmpleados: data?.numEmpleados || '',
		masaSalarial: data?.masaSalarial || '',
		ubicacion: data?.ubicacion || '',
	})

	const [errors, setErrors] = useState<Record<string, string>>({})

	const handleSubmit = () => {
		const newErrors: Record<string, string> = {}

		if (!formData.numEmpleados.trim()) {
			newErrors.numEmpleados = 'Ingresa el número de empleados'
		} else if (
			isNaN(Number(formData.numEmpleados)) ||
			Number(formData.numEmpleados) <= 0
		) {
			newErrors.numEmpleados = 'Debe ser un número mayor a 0'
		}

		if (!formData.masaSalarial.trim()) {
			newErrors.masaSalarial = 'Ingresa la masa salarial'
		}

		if (!formData.ubicacion.trim()) {
			newErrors.ubicacion = 'Ingresa la ubicación'
		}

		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors)
			return
		}

		onNext(formData)
	}

	const isFormValid =
		formData.numEmpleados.trim() &&
		formData.masaSalarial.trim() &&
		formData.ubicacion.trim()

	return (
		<div className="flex h-full w-full flex-col">
			<div className="flex-1 overflow-y-auto">
				<div className="flex w-full flex-col items-center gap-8">
					<h2 className="font-parkinsans text-center text-2xl leading-8 font-medium text-blue-800">
						Completa los datos de
						<br />
						tu empresa
					</h2>

					{/* Form inputs */}
					<div className="flex w-full flex-col gap-6">
						<InputText
							label="Número de empleados"
							labelPosition="internal"
							size="l"
							placeholder="Número de empleados"
							type="number"
							value={formData.numEmpleados}
							onChange={(e) => {
								setFormData({ ...formData, numEmpleados: e.target.value })
								setErrors({ ...errors, numEmpleados: '' })
							}}
							errorText={errors.numEmpleados}
							required
						/>
						<InputText
							label="Masa salarial"
							labelPosition="internal"
							size="l"
							placeholder="Masa salarial"
							value={formData.masaSalarial}
							onChange={(e) => {
								setFormData({ ...formData, masaSalarial: e.target.value })
								setErrors({ ...errors, masaSalarial: '' })
							}}
							errorText={errors.masaSalarial}
							required
						/>
						<InputText
							label="Ubicación"
							labelPosition="internal"
							size="l"
							placeholder="Ubicación"
							value={formData.ubicacion}
							onChange={(e) => {
								setFormData({ ...formData, ubicacion: e.target.value })
								setErrors({ ...errors, ubicacion: '' })
							}}
							errorText={errors.ubicacion}
							required
						/>
					</div>
				</div>
			</div>

			<div className="flex w-full shrink-0 flex-col items-center justify-start gap-2 bg-white pt-4 md:flex-row md:justify-between md:bg-transparent md:pt-8">
				<Button
					variant="primary"
					appearance="ghost"
					size="l"
					onClick={onBack}
					className="order-2 w-full gap-2 rounded-xl px-4 py-3 text-sm leading-4 md:order-1 md:w-auto md:px-6 md:py-4 md:text-base md:leading-5"
				>
					<Icon name="arrow-left" className="size-4" />
					Atrás
				</Button>
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={handleSubmit}
					disabled={!isFormValid}
					className="order-1 w-full md:order-2 md:w-auto"
				>
					Siguiente
					<Icon name="arrow-right" className="size-3.5" />
				</Button>
			</div>
		</div>
	)
}
